/**
 * Store constants of submission status's type, color and label
 */
const TYPE = {
  moreinfo: 0,
  incomplete: 1,
  fasttrack: 2,
  pending: 3,
  approved: 4,
  rejected: 5,
};

const INFO = [];
INFO[TYPE.moreinfo] = { color: '#D84078', label: 'Needs more information' };
INFO[TYPE.incomplete] = { color: '#D84078', label: 'Incomplete' };
INFO[TYPE.fasttrack] = { color: '#0085d8', label: 'License Submitted' };
INFO[TYPE.pending] = { color: '#f0ad4e', label: 'Under Review' };
INFO[TYPE.approved] = { color: '#17a08c', label: 'Accepted' };
INFO[TYPE.rejected] = { color: '#D8DBDE', label: 'Not Accepted' };

INFO.forEach((info, index) => {
  info.deletable = index === TYPE.incomplete;
  info.editable = index <= TYPE.incomplete;
});

export default {
  getInfo(submissionStatus) {
    return INFO[TYPE[submissionStatus]];
  },
  TYPE,
  INFO,
};



// WEBPACK FOOTER //
// ./src/assets/data/viddsee/submissionStatus.js